import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as mealPlansApi from '@/features/meal-plans/meal-plans.api';

interface MealPlanPickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const MealPlanPicker = ({
  label = 'Meal plan',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: MealPlanPickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.mealPlans',
      fetch: async (search) => {
        const res = await mealPlansApi.listMealPlans({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await mealPlansApi.getMealPlan(id);
        } catch {
          return null;
        }
      },
      toOption: (m) => ({
        value: m.id,
        label: m.name,
        description: m.code ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a meal plan"
      searchPlaceholder="Search meal plans..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
